import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 28811 37492"
    {...props}
  >
    <path
      d="M28811 26008c0 2187-565 4155-1697 5902-1123 1749-2778 3117-4957 4105-2178 987-4762 1477-7743 1477-3580 0-6536-676-8858-2018-1646-971-2981-2271-4011-3893C515 29960 0 28381 0 26844c0-887 313-1646 929-2288 616-634 1402-946 2355-946 777 0 1428 245 1960 743 540 490 996 1225 1376 2204 456 1148 963 2120 1495 2888 540 777 1292 1418 2263 1925 979 499 2254 752 3842 752 2170 0 3943-507 5303-1520 1359-1013 2043-2280 2043-3800 0-1207-363-2187-1097-2930-735-752-1689-1326-2855-1723-1156-397-2718-819-4661-1266-2601-608-4787-1326-6536-2137-1756-819-3149-1933-4180-3344-1030-1410-1544-3158-1544-5260 0-1993 540-3767 1629-5320 1089-1545 2668-2736 4729-3572C9111 414 11534 0 14321 0c2221 0 4146 279 5776 828 1621 557 2972 1291 4045 2203 1064 913 1849 1875 2348 2880 489 1005 742 1993 742 2947 0 870-312 1664-928 2364-617 701-1394 1047-2314 1047-844 0-1478-211-1917-624-439-423-912-1115-1419-2069-667-1368-1452-2440-2381-3209-920-768-2407-1148-4459-1148-1891 0-3427 414-4585 1250-1165 835-1748 1832-1748 3006 0 726 194 1350 591 1882 397 524 946 980 1639 1360 692 380 1393 676 2102 895 709 211 1883 524 3513 937 2043 482 3901 1005 5556 1588 1655 574 3066 1275 4231 2103 1165 819 2068 1866 2719 3124 650 1267 979 2812 979 4644z"
      style={{
        fill: "#2b2a29",
        fillRule: "nonzero",
      }}
      className="fill"

    />
  </svg>
)
export default SvgComponent
